import React from 'react';

const ExcelIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18.271" height="17" viewBox="0 0 18.271 17">
      <g id="_6296676_excel_microsoft_office_office365_icon" data-name="6296676_excel_microsoft_office_office365_icon" transform="translate(-0.1 -4.5)">
        <rect id="Rectangle_611" data-name="Rectangle 611" width="7.043" height="4.257" transform="translate(11.329 8.743)" fill="#21a365" />
        <rect id="Rectangle_612" data-name="Rectangle 612" width="7.043" height="4.257" transform="translate(11.329 13)" fill="#107c41" />
        <rect id="Rectangle_613" data-name="Rectangle 613" width="7.029" height="4.257" transform="translate(4.3 8.743)" fill="#107c41" />
        <path
          id="Path_10440"
          data-name="Path 10440"
          d="M36.614,68.257V64H29.6v7.671a.829.829,0,0,0,.829.829H42.814a.829.829,0,0,0,.829-.829V68.257Z"
          transform="translate(-25.286 -51)"
          fill="#185b37"
        />
        <path id="Path_10441" data-name="Path 10441" d="M84.814,4.5H78.6V8.757h7.057V5.329A.851.851,0,0,0,84.814,4.5Z" transform="translate(-67.286)" fill="#33c481" />
        <path id="Path_10442" data-name="Path 10442" d="M36.7,4.5H30.529a.829.829,0,0,0-.829.829V8.743h7.014V4.5Z" transform="translate(-25.371)" fill="#21a365" />
        <path
          id="Path_10443"
          data-name="Path 10443"
          d="M8.586,40.786H1.014A.921.921,0,0,1,.1,39.871V32.414a.921.921,0,0,1,.914-.914H8.586a.921.921,0,0,1,.914.914v7.457A.911.911,0,0,1,8.586,40.786Z"
          transform="translate(0 -23.143)"
          fill="#17864c"
        />
        <g id="Group_16322" data-name="Group 16322" transform="translate(2.714 10.5)">
          <path
            id="Path_10444"
            data-name="Path 10444"
            d="M21.557,51.629,21,50.614c-.229-.4-.371-.671-.529-.971h-.014c-.129.3-.257.571-.471.971l-.5,1.014H18.4l1.543-2.586-1.5-2.543h1.1l.557,1.057c.171.314.3.571.429.857h.029c.143-.314.243-.543.414-.857l.557-1.057h1.086L21.086,49l1.586,2.629Z"
            transform="translate(-18.4 -46.5)"
            fill="#fff"
          />
        </g>
        <path
          id="Path_10445"
          data-name="Path 10445"
          d="M35.586,37.3v7.543a.921.921,0,0,1-.914.914H30.4v.814h5.029a.921.921,0,0,0,.914-.914V38.2A.885.885,0,0,0,35.586,37.3Z"
          transform="translate(-25.971 -28.114)"
          opacity="0.2"
        />
      </g>
    </svg>
  );
};

export default ExcelIcon;
